import { Component } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-cross',
  templateUrl: './cross.component.html',
})
export class CrossComponent extends Icon {
}
